const CustomCircularProgress = ({borderColor,borderTopColor,borderBottomColor,top,left}) => {
    return ( 
            <div style={{
                position:"absolute",
                top: top,
                left: left,
                zIndex:"2",
                width:"50px",
                height:"50px",
                border: `5px solid ${borderColor}`,
                borderBottom: `5px solid ${borderBottomColor}`,
                borderTop: `5px solid white ${borderTopColor}`,
                borderRadius: "50%",
                animation: "spin2 2s linear infinite",
                backgroundColor: "#00000050"
                }}>
            </div>
     );
}
export default CustomCircularProgress;